import { useRoles } from "@/hooks/useRoles";

interface RoleBadgesProps {
  /** Role ids (uuids). */
  roles: string[];
  fallback?: string;
}

/**
 * Renders a list of color-coded role badges. Role display name + color are
 * resolved from the roles table via useRoles().
 */
export function RoleBadges({ roles, fallback = "—" }: RoleBadgesProps) {
  const { formatRole, roleColorStyle } = useRoles();
  const filtered = roles.filter(Boolean);
  if (filtered.length === 0) return <span>{fallback}</span>;

  return (
    <span className="role-badges">
      {filtered.map((roleId) => (
        <span key={roleId} className="role-badge" style={roleColorStyle(roleId)}>
          {formatRole(roleId)}
        </span>
      ))}
    </span>
  );
}
